<template>

  <div class="ShareModal">

    <transition name="ShareModal-items-">

      <share-items class="ShareModal-items"
        v-show="isOpen" />

    </transition>

    <transition name="ShareModal-background-">

      <div class="ShareModal-background"
        v-show="isOpen"
        @click="close">
      </div>

    </transition>

  </div>
</template>

<script>
export default {
  name: 'ShareModal',

  computed: {
    isOpen () { return this.$store.state.share.modalIsOpen },
    window () { return this.$store.state.window }
  },

  watch: {
    isOpen () {
      this.$store.dispatch('window/setPreventScroll', this.isOpen)
    },

    // Close the modal if the window height is ever >= 420px
    'window.height' () {
      if (this.window.height >= 420) this.close()
    }
  },

  mounted () {
    this.$nextTick(this.addEventListeners)
  },

  beforeDestroy () {
    this.removeEventListeners()
  },

  methods: {
    /**
     * Add event listeners
     */
    addEventListeners () {
      document.addEventListener('keyup', this.handleKeyUp)
    },

    /**
     * Remove event listeners
     */
    removeEventListeners () {
      document.removeEventListener('keyup', this.handleKeyUp)
    },

    /**
     * Handle keyup event
     * @param  {Object} event
     */
    handleKeyUp (event) {
      switch (event.keyCode) {
        case 27: // esc
          this.close()
          break
      }
    },

    /**
     * Close the share sheet
     */
    close () {
      this.$store.dispatch('share/closeModal')
    }
  }
}
</script>

<style>
@import 'properties';

.ShareModal {
  position: fixed;
  z-index: 900;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--unit);
  pointer-events: none;

  @media (min-height: 420px) {
    display: none;
  }
}

.ShareModal-items {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 78px;
  padding: 0 var(--unit-075);
  border-radius: var(--radius);
  background-color: var(--c-blue);
  pointer-events: auto;

  @media (orientation: landscape) {
    flex-direction: row;
  }
}

.ShareModal-items--enter-active,
.ShareModal-items--leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
  transform: scale(1);
}

.ShareModal-items--enter,
.ShareModal-items--leave-to {
  transform: scale(0.95);
  opacity: 0;
}

.ShareModal-items .ShareItem-icon {
  /* width: 60px !important; */
  /* height: 60px !important; */
}

.ShareModal-items > * + * {
  margin: var(--unit-05) 0 0 0;

  @media (orientation: landscape) {
    margin: 0 0 0 var(--unit-05);
  }
}

.ShareModal-background {
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: auto;
  /* background-color: var(--c-black-tx); */
}

.ShareModal-background--enter-active,
.ShareModal-background--leave-active {
  transition: opacity 0.25s ease;
}

.ShareModal-background--enter,
.ShareModal-background--leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// ShareModal.vue?119033e1